import styled, { css } from 'styled-components';

import { ASSET_PATH } from 'assetsPath';

export const IntegrationSprite = styled.span`
    background:url(${ASSET_PATH.IMAGES}/travelIntegration/integrationSprite.png) no-repeat;
    display: inline-block;
    background-size: 160px 40px;
    ${(props) => {
		switch (props.icon) {
			case 'searchIcon':
				return css`
				background-position: -1px -1px;
				width: 19px;
				height: 19px;`;
			case 'blueArrowIcon':
				return css`
				background-position: -2px -23px;
				width: 16px;
				height: 11px;`;
			case 'ssoLoginIcon':
				return css`
				background-position: -22px -1px;
				width: 25px;
				height: 25px;`;
			case 'hrmsIcon':
				return css`
				background-position: -50px -2px;
				width: 25px;
				height: 23px;`;
			case 'expenseMngmtIcon':
				return css`
				background-position: -78px -3px;
				width: 23px;
				height: 20px;`;
			case 'travelRqstApiIcon':
				return css`
				background-position: -104px -1px;
				width: 30px;
				height: 28px;`;
			case 'ssoTagIcon':
				return css`
				background-position: -137px -1px;
				width: 16px;
				height: 16px;`;
			case '.chevronIcon ':
				return css`
				background-position: -20px -28px;
				width: 5px;
				height: 8px;`;
			default:
				break;
		}
	}}
`;

export const IntegrationSpriteIcons = styled.span`
    background:url(${ASSET_PATH.IMAGES}mobile/travelIntegration/integrationSprite.png) no-repeat;
    display: inline-block;
    background-size: 360px 360px;
    ${(props) => {
		switch (props.icon) {
			case 'hamburgerLightIcon':
				return css`
				background-position: -25px -3px;
    		width: 20px;
				margin-left: 12px;
    		height: 13px;`;
			case 'hamburgerDarkIcon':
				return css`
				background-position: -2px -3px;
    		width: 20px;
    		height: 13px;`;
			case 'chevronIcon':
				return css`
				background-position: -48px -4px;
    		width: 5px;
				margin-left: 8px;
    		height: 9px;`;
			case 'blueArrowIcon':
				return css`
				background-position: -2px -23px;
				width: 16px;
				height: 11px;`;
			case 'ssoLoginIcon':
				return css`
				background-position: -22px -1px;
				width: 25px;
				height: 25px;`;
			case 'hrmsIcon':
				return css`
				background-position: -50px -2px;
				width: 25px;
				height: 23px;`;
			case 'expenseMngmtIcon':
				return css`
				background-position: -78px -3px;
				width: 23px;
				height: 20px;`;
			case 'travelRqstApiIcon':
				return css`
				background-position: -104px -1px;
				width: 30px;
				height: 28px;`;
			case 'sparklesIcon':
				return css`
				background-position: -2px -18px;
				width: 15px;
				height: 15px;
				margin-left: 8px;
				`;
			case 'closeIcon':
				return css`
				background-position: -46px -14px;
				width: 10px;
				height: 10px;
				margin-left: 8px;
				`;
			default:
				break;
		}
	}}
`;
